import { render, staticRenderFns } from "./allCategories.vue?vue&type=template&id=e63b31b2&scoped=true&"
import script from "./allCategories.vue?vue&type=script&lang=js&"
export * from "./allCategories.vue?vue&type=script&lang=js&"
import style0 from "./allCategories.vue?vue&type=style&index=0&id=e63b31b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63b31b2",
  null
  
)

export default component.exports